var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveBonds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67499",
    "data-name": "Group 67499",
    transform: "translate(-984 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22414",
    "data-name": "Rectangle 22414",
    width: 72,
    height: 72,
    transform: "translate(984 756)",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-document",
    transform: "translate(960.667 772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67409",
    "data-name": "Group 67409",
    transform: "translate(42.667 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67408",
    "data-name": "Group 67408",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80469",
    "data-name": "Path 80469",
    d: "M67.667,23.333A1.667,1.667,0,0,1,66,25H52.667a1.667,1.667,0,0,1,0-3.333H66A1.667,1.667,0,0,1,67.667,23.333Zm-6.667,5H52.667a1.667,1.667,0,0,0,0,3.333H61a1.667,1.667,0,0,0,0-3.333ZM76,17.475V31.666A8.343,8.343,0,0,1,67.667,40H51a8.343,8.343,0,0,1-8.333-8.333V8.333A8.343,8.343,0,0,1,51,0h7.525a11.6,11.6,0,0,1,8.25,3.417l5.807,5.81A11.585,11.585,0,0,1,76,17.475ZM64.418,5.773a8.35,8.35,0,0,0-1.752-1.3v7.193a1.667,1.667,0,0,0,1.667,1.667h7.193a8.305,8.305,0,0,0-1.3-1.75Zm8.248,11.7c0-.275-.053-.538-.078-.808H64.333a5,5,0,0,1-5-5V3.411c-.27-.025-.535-.078-.808-.078H51a5,5,0,0,0-5,5V31.666a5,5,0,0,0,5,5H67.667a5,5,0,0,0,5-5Z",
    transform: "translate(-42.667 0)",
    fill: "#ff8383"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBonds);
export default __webpack_public_path__ + "static/media/active-bonds.215f649268ab4f309302f0fa6d3a392b.svg";
export { ForwardRef as ReactComponent };